// EditCategory.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EditCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

const EditCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { category } = location.state || {};
  const [imageUrl, setImageUrl] = useState(category ? category.photo : '');
  const [NewImageView, setNewImageView] = useState('');
  const [newImage, setNewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState(category ? category.name.en : '');
  const [nameAr, setNameAr] = useState(category ? category.name.ar : '');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [BrandList, setBrandList] = useState([]);
  console.log("category", category)
  useEffect(() => {
    if (!category) {
      navigate('/Categories');
    }
  }, [category, navigate]);

  const handleCategoryClick = (category) => {
    const formattedOptions = category.brands.map(option => ({
      value: option.id,
      label: `${option.name.en} - ${option.name.ar}`,
    }));

    setSelectedOptions(formattedOptions); // Reset selected options

  };

  useEffect(() => {
    handleCategoryClick(category)
  }, [category]);

  useEffect(() => {
    fetchBrands()
  }, []);
  const fetchBrands = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/brands`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data", data)
        setBrandList(data.brands); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch brand');
      }
    } catch (err) {
      setError('Failed to fetch brand');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
    if (!name) {
      toast.error('Please enter a category name.');
      return;
    }
    if (!nameAr) {
      toast.error('Please enter a category name arabic');
      return;
    }
    if (!imageUrl) {
      toast.error('Please select an image.');
      return;
    }
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
      const formData = new FormData();
      formData.append('name[en]', name);
      formData.append('name[ar]', nameAr);
      formData.append('_method', 'PATCH');
      // Append selected options to the formData
      selectedOptions.forEach(option => {
        formData.append('brand_ids[]', option.value); // 'value' contains the ID
      });
 if (NewImageView) {
        formData.append('photo', newImage);
      }
      // Check and append parent_id to the formData
      formData.append('parent_id', category.parent_id ? category.parent_id : '');
      const response = await fetch(baseUrl + `/categories/${category.id}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'x-api-key': 'web-app',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      const data = await response.json();
      console.log("data", data)
      if (response.ok) {
        toast.success('Edited successfully');
        navigate('/Categories');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        toast.error('Please select a valid image file (jpeg, jpg, png).');
        return;
      }

      setImageUrl(file); // Store the file object
      setNewImage(file); // Store the file object
      setNewImageView(URL.createObjectURL(event.target.files[0]));
    }
  };


  const formattedOptions = BrandList.map(option => ({
    value: option.id,
    label: `${option.name.en} - ${option.name.ar}`,
  }));

  const handleChange = selected => {
    setSelectedOptions(selected);
  };


  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#fff",
      fontSize: 20,
      color: "#000",
      border: "1px solid #ccc",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #888",
      },
      width: "100%",
      margin: "0 auto", // Center align
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? "rgba(154, 57, 57, 0.8)"
        : isFocused
          ? "rgba(154, 57, 57, 0.2)"
          : "#fff",
      color: isSelected ? "#fff" : "#000",
      fontSize: 18,
      padding: 10,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(154, 57, 57, 0.2)",
      color: "#000",
      fontSize: 16,
      borderRadius: 5,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#000",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#000",
      ":hover": {
        backgroundColor: "rgba(154, 57, 57, 0.8)",
        color: "#fff",
      },
    }),
  };
  return (
    <div style={{ width: '100%' }}>
      <h2 style={{ color: "#e02828", textAlign: 'center' }}>Edit category</h2>
      <div className="edit-category-container">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        <div className="edit-category">
          {/* <h2 style={{color:"#e02828"}}>{name}</h2> */}
          <div className="form-group">
            <label htmlFor="name">category name english</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                backgroundColor: "#fff", fontSize: 20, width: "70%",
                padding: '10px',
                border: '1px solid #717171',
                borderRadius: '8px', color: "#000"
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="name">category name arabic</label>
            <input
              type="text"
              id="name"
              value={nameAr}
              onChange={(e) => setNameAr(e.target.value)}
              style={{
                backgroundColor: "#fff", fontSize: 20, width: "70%",
                padding: '10px',
                border: '1px solid #717171',
                borderRadius: '8px', color: "#000"
              }}
            />
          </div>
          <div style={{
            width: "70%",
            color: "#000",
            display: 'contents'
          }}>
            <h3>Select Brands</h3>
            <Select
              options={formattedOptions}
              isMulti
              onChange={handleChange}
              value={selectedOptions}
              styles={customStyles}
            />
          </div>
          <div className="form-group">
            <label htmlFor="imageUrl">Image</label>
            <div className="image-preview">
              <img src={NewImageView || imageUrl} alt="Category" className="category-image" />
              <label htmlFor="imageUpload" className="edit-image" style={{ backgroundColor: "rgb(154, 57, 57)" }}>
                Edit
              </label>
              <input
                type="file"
                id="imageUpload"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />
            </div>
          </div>
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Categories')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default EditCategory;
